(function () {
    'use strict';
    // Directives used to organize our sidebar

    angular.module('GorillaBoy')
    .directive('actionBar', [
        '$rootScope',
        '$timeout',
        '$translate',
        'authenticatedUser',
        'DocumentStateService',
        'PathManager',
        'SessionManager',
        'SourceConstant',
        'SignalProvider',
        'AppConstants',
        function ($rootScope, $timeout, $translate, authenticatedUser, DocumentStateService, PathManager, SessionManager, SourceConstant, SignalProvider, AppConstants) {
            var TYPE_FOLDER = 'FOLDER',
                TYPE_DOCUMENT = 'DOCUMENT',
                ViewTypes = AppConstants.ViewTypes;

            return {
                template: '<div class="top-action-bar" ng-include="templateURL"></div>',
                scope: true,
                link: function(scope, element, attrs) {
                    scope.MODE = {
                        NONE_SELECTED: 0,
                        SINGLE_SELECTED: 1,
                        MULTI_SELECTED: 2
                    };
                    scope.ViewTypes = ViewTypes;
                    initActionBar();
                    scope.$watch('layout.view', function(view) {
                        switch(view) {
                            case ViewTypes.DOCUMENT_TYPE:
                                scope.RightTabTypes = AppConstants.RightTabTypes;

                                if (scope.layout.isAnonymous) {
                                    scope.templateURL = './shared/documentViewActionBarForAnonymousUsers.html';
                                } else {
                                    scope.templateURL = './shared/documentViewActionBar.html';
                                }

                                scope.showShareButton = function() {
                                    var isFileInShareableState = !scope.isFileRecycled();
                                    var anyOptionAvailable = scope.hasSharePermission() || scope.hasShareLinkPermission() || scope.showPermissionsButton();
                                    return isFileInShareableState && anyOptionAvailable;
                                };

                                scope.isCreateApprovalButtonVisible = function() {
                                    return !scope.isFileRecycled() &&
                                        !$rootScope.isFeatureEnabled($rootScope.Features.UI.APPROVAL_V2_DISABLED) && !authenticatedUser.getUserInfo().MinimalUser;
                                };

                                scope.showPermissionsButton = function() {
                                    return scope.layout.hasRightSidebar;
                                };
                                
                                // manually set selected item
                                scope.selectedItems.push({
                                    type: TYPE_DOCUMENT,
                                    item: scope.metadata
                                });
                                break;
                            case ViewTypes.FOLDER_TYPE:
                            case ViewTypes.OWN_TYPE:
                            case ViewTypes.SHARED_TYPE:
                            case ViewTypes.SHARED_BY_ME_TYPE:
                            case ViewTypes.AWAITING_FEEDBACK_TYPE:
                            case ViewTypes.OUT_FOR_REVIEW_TYPE:
                            case ViewTypes.SEARCH_TYPE:
                            case ViewTypes.FAVORITES:
                            case ViewTypes.NOTE_TYPE:
                                scope.isShareButtonEnabled = function() {
                                    return scope.layout.view !== ViewTypes.SEARCH_TYPE && !authenticatedUser.getUserInfo().MinimalUser;
                                };

                                scope.isMultiSelectActionButtonEnabled = function() {
                                    return !authenticatedUser.getUserInfo().MinimalUser;
                                };

                                scope.templateURL = './shared/fileBrowserActionBar.html';
                                scope.showCurrentFolderOption = view === ViewTypes.FOLDER_TYPE;
                                scope.$on(SignalProvider.Selection.SelectionUpdated, updateActionBar);
                                break;
                            case ViewTypes.RECYCLE_TYPE:
                                scope.templateURL = './shared/recycleActionBar.html';
                                break;
                            case ViewTypes.RECOVERY_TYPE:
                                scope.templateURL = './shared/recoveryActionBar.html';
                                break;
                            case AppConstants.Tasks.Views.AssignedTasks:
                            case AppConstants.Tasks.Views.MyTasks:
                            case AppConstants.Tasks.Views.ArchivedTasks:
                                scope.templateURL = './shared/tasksActionBar.html';
                                break;
                            default:
                                break;
                        }

                        if (authenticatedUser.getUserInfo() && !authenticatedUser.getUserInfo().MinimalUser && view === ViewTypes.FOLDER_TYPE || view === ViewTypes.OWN_TYPE) {
                            scope.showUploadButton = true;
                        } else {
                            scope.showUploadButton = false;
                        }

                    });

                    function initActionBar() {
                        scope.templateURL = '';
                        scope.showActionDropdownMenu = false;
                        scope.showEditDropdown = false;
                        scope.curMode = scope.MODE.NONE_SELECTED;
                        scope.selectedItems = [];
                    }

                    function updateActionBar() {
                        // hide dropdown menu
                        scope.showActionDropdownMenu = false;
                        scope.showEditDropdown = false;
                        // update selected items
                        scope.selectedItems = getSelectedItems();
                        // update mode
                        if (scope.selectedItems.length === 0) {
                            scope.curMode = scope.MODE.NONE_SELECTED;
                        } else if(scope.selectedItems.length === 1) {
                            scope.curMode = scope.MODE.SINGLE_SELECTED;
                        } else {
                            scope.curMode = scope.MODE.MULTI_SELECTED;
                        }
                    }

                    function getSelectedItems() {
                        var selectedFileIds = scope.fileManagerInstance.selectedFiles();
                        var selectedFolderIds = scope.fileManagerInstance.selectedFolders();
                        var selectedItems = [];

                        angular.forEach(selectedFileIds, function(fileId) {
                            selectedItems.push({
                                type: TYPE_DOCUMENT,
                                item: scope.__getFileById(TYPE_DOCUMENT, fileId)
                            });
                        });
                        angular.forEach(selectedFolderIds, function(folderId) {
                            selectedItems.push({
                                type: TYPE_FOLDER,
                                item: scope.__getFileById(TYPE_FOLDER, folderId)
                            });
                        });

                        return selectedItems;
                    }

                    scope.TYPE_DOCUMENT = TYPE_DOCUMENT;
                    scope.TYPE_FOLDER = TYPE_FOLDER;

                    scope.toggleActionDropdownMenu = function() {
                        scope.showActionDropdownMenu = !scope.showActionDropdownMenu;
                    };

                    scope.closeActionDropdownMenu = function() {
                        scope.showActionDropdownMenu = false;
                    };

                    scope.toggleEditDropdown = function() {
                        scope.showEditDropdown = !scope.showEditDropdown;
                    };

                    scope.createApproval = function () {
                        var path = window.location.pathname;
                        var approvalAppLinkPrefix = path.substring(0, path.lastIndexOf("/"));
                        var createRouteURI = approvalAppLinkPrefix + "/approvals/index.html#/createApproval/file/" + scope.metadata.Id;

                        window.open(createRouteURI, '_blank');
                    };
                }
            };
    }]);
}());
